goog.provide("shadow.js.shim.module$$carbon$icons_react$es$Upload$default");
shadow.js.shim.module$$carbon$icons_react$es$Upload$default = shadow.js.require(376, {}).default;
